import { MessageDescriptor } from 'react-intl'

import { PaymentBanksActionType } from './actions'
import {
  CLEAR_BANK_SETTLEMENT,
  CREATE_BANK_LINK,
  CREATE_BANK_LINK_SUCCES,
  FETCH_BANK_LINK_TOKEN_FOR_REFRESH,
  FETCH_BANK_TYPE,
  FETCH_BANKS_TYPE,
  SET_BANK_SETTLEMENT_TYPE,
  SET_BANK_TYPE,
  SET_BANKS_TYPE,
  SET_FETCH_BANK_ERROR_TYPE,
  SET_FETCH_BANKS_ERROR_TYPE,
  SET_FETCHING_BANK_TYPE,
  SET_FETCHING_BANKS_TYPE,
  UPDATE_BANK_LINK_SUCCES
} from './actionTypes'
import { Bank } from './types'

export const INITIAL_STATE = {
  banks: [],
  byId: {},
  fetching: false
}

type PaymentBankStateType = {
  readonly bank?: Bank
  readonly error?: string
  readonly fetching: boolean
}

type BankSettlementType = {
  readonly bank?: Bank
  readonly message: MessageDescriptor
  readonly settlementResponse: any
}

export type PaymentBanksStateType = {
  readonly bankSettlement?: BankSettlementType | undefined
  readonly banks: Bank[]
  readonly byId: { [id: string]: PaymentBankStateType }
  readonly error?: string
  readonly fetching: boolean
  readonly newLinkedBank?: Bank
}

const byIdReducer = (state: PaymentBankStateType, action: PaymentBanksActionType) => {
  switch (action.type) {
    case SET_BANK_TYPE:
      return { ...state, bank: action.payload.bank }
    case SET_FETCHING_BANK_TYPE:
      return { ...state, fetching: action.payload.fetching }
    case SET_FETCH_BANK_ERROR_TYPE:
      return { ...state, error: action.payload.error }
    default:
      return state
  }

  return state
}

const bankTransferReducer = (
  state: PaymentBanksStateType = INITIAL_STATE,
  action: PaymentBanksActionType
) => {
  if (!action) return state

  switch (action.type) {
    case SET_BANKS_TYPE:
      return { ...state, banks: action.payload }
    case SET_BANK_SETTLEMENT_TYPE:
      return { ...state, bankSettlement: action.payload }
    case SET_FETCHING_BANKS_TYPE:
      return { ...state, fetching: action.payload }
    case SET_FETCH_BANKS_ERROR_TYPE:
      return { ...state, error: action.payload }
    case FETCH_BANKS_TYPE:
      return { ...state, error: undefined }
    case CREATE_BANK_LINK:
      return { ...state, newLinkedBank: undefined }
    case CLEAR_BANK_SETTLEMENT:
      return { ...state, bankSettlement: undefined }
    case FETCH_BANK_LINK_TOKEN_FOR_REFRESH:
      return { ...state, newLinkedBank: undefined }
    case CREATE_BANK_LINK_SUCCES:
      return { ...state, newLinkedBank: action.payload.data }
    case UPDATE_BANK_LINK_SUCCES:
      return { ...state, newLinkedBank: action.payload.data }
    case FETCH_BANK_TYPE:
    case SET_BANK_TYPE:
    case SET_FETCHING_BANK_TYPE:
    case SET_FETCH_BANK_ERROR_TYPE:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: byIdReducer(state.byId[action.payload.id], action)
        }
      }
    default:
      return state
  }

  return state
}

export default bankTransferReducer
